import axios from "axios";
import { BASE_URL } from "../Utils/base_url";
const AjouteReservationRequest = async (data) => {

    return await axios.post(`${BASE_URL}/api/client/ajouteReservation`, data, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenClient'),
        }
    });
}

const AjouteConfirmation = async (data) => {
    return await axios.post(`${BASE_URL}/api/client/confirmerReservation`, data, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('tokenClient'),
      }
    });
  }

  const AjouteAvisRestaurant = async (data) => {
    return await axios.post(`${BASE_URL}/ajouteAvis`, data);
  }


  const AfficheCritereAvis = async (data) => {
    return await axios.get(`${BASE_URL}/afficheCritereAvis`, data);
  }


  const AjouteAvisProduit = async (data) => {
    return await axios.post(`${BASE_URL}/ajouteAvisProduit`, data);
  }

  const AnnulerReservation = async (data) => {
    return await axios.post(`${BASE_URL}/api/client/annulerReservation`, data, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('tokenClient'),
      }
    });
  }

export { AjouteReservationRequest, AjouteConfirmation, AjouteAvisRestaurant, AjouteAvisProduit, AnnulerReservation, AfficheCritereAvis };